import i18next from 'i18next';

import { APIClient } from '@core';
import { trackEvent } from '@lib';
import { LanguageItems } from '@type';

import { forEachUniqueSources, updateDateLocale } from '..';

export const changeLanguage = (selectedLanguage: string) => {
  const language = Object.values(LanguageItems).find(
    item => item.code === selectedLanguage
  );
  if (!language) return;

  const { code, fullCode, native } = language;
  trackEvent({
    category: 'AppLanguage',
    action: 'change',
    name: `from ${i18next.language.toUpperCase()} to ${native.toUpperCase()}`,
  });
  void i18next.changeLanguage(code);
  void forEachUniqueSources(source => void source.syncDeviceLang());
  updateDateLocale(code);
  APIClient.setLanguage(fullCode);
};
